import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionIcon } from './PermissionIcon';
import { EnhancedPermissionsSet } from './types';

type PermissionDisplayLineProps = {
  permissionSet: EnhancedPermissionsSet;
};

export const PermissionDisplayLine: FC<PermissionDisplayLineProps> = ({ permissionSet }) => {
  const i18next = useTranslation();

  // permissionSet should either have `permission` or a pair of brewery permissions.
  if (permissionSet.permission) {
    return (
      <div key={`permission-${permissionSet.permission}`} className="permission-item">
        <div>{i18next.t(`permissionDescriptions.${permissionSet.permission}`)}</div>
        <div>
          <PermissionIcon hasPermission={permissionSet.hasPermission} />
        </div>
      </div>
    );
  }

  if (
    permissionSet.breweryPermissionSummary &&
    permissionSet.permissionAtOwnBrewery &&
    permissionSet.permissionAtAllBreweries
  ) {
    return (
      <div key={`permission-${permissionSet.breweryPermissionSummary}`}>
        <div className="brewery-permission-item-header">{i18next.t(permissionSet.breweryPermissionSummary)}</div>
        <div className="permission-item permission-item-brewery">
          <div>{i18next.t('userProfile.atYourBrewery')}</div>
          <PermissionIcon hasPermission={permissionSet.hasPermissionAtOwnBrewery} />
        </div>
        <div className="permission-item permission-item-brewery">
          <div>{i18next.t('userProfile.atAllBreweries')}</div>
          <PermissionIcon hasPermission={permissionSet.hasPermissionAtAllBreweries} />
        </div>
      </div>
    );
  }
};
